<dx-box height="100%" width="100%" direction="col">
    <dxi-item [ratio]="1" class="cc-white-background">
        <div class="textarea-container">
            <dx-text-area class="textarea-content" [readOnly]="true" [(value)]="previousNotes"></dx-text-area>
        </div>
    </dxi-item>
    <dxi-item baseSize="auto">
        <div *dxTemplate class="button-container">
            <dx-toolbar>
                <dxi-item location="before">
                    <div *dxTemplate>
                        <dx-button
                            type="default"
                            text="Close"
                            [icon]="iconClose"
                            (onClick)="onCloseClick()"
                        ></dx-button>
                    </div>
                </dxi-item>
            </dx-toolbar>
        </div>
    </dxi-item>
</dx-box>
